import tokens from "@nitro/harvia-style-dictionary/tokens/base.json"
import React, { useEffect, useRef, useState } from "react"
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io"
import { CSSTransition } from "react-transition-group"
import { isBrowser } from "../../../utils"
import * as styles from "./NavLink.module.scss"
import NavLinks, { NavLinkNode } from "./NavLinks"

type NavLinkProps = {
  level: number
  subLinks: NavLinkNode[]
  link: JSX.Element
  isCurrentPage?: boolean
  hasCurrentPage?: boolean
}

const NavLink = (props: NavLinkProps) => {
  // console.debug("rendering NavLink", props)

  const { level, hasCurrentPage = false, isCurrentPage = false, subLinks } = props

  const [isOpen, setOpen] = useState(props.level > 1 && hasCurrentPage)

  const thisItem = useRef<HTMLLIElement>(null)

  const onOpenClick = (/*e: React.MouseEvent*/): void => {
    // timeout, jotta avattava navigaatio ei heti sulkeudu windowClickHandlerin kautta
    const val = !isOpen
    setTimeout(() => {
      setOpen(val)
    }, 0)
  }

  useEffect(() => {
    function windowClickHandler(e: MouseEvent): void {
      if (!isOpen) {
        return
      }
      // find if clicked inside current nav tree, else close navigation
      let navClick = false
      let cur = e.target as HTMLElement
      while (cur) {
        //console.log(cur);
        if (cur === thisItem.current) {
          navClick = true
          break
        }
        cur = cur.parentElement as HTMLElement
      }

      if (!navClick) setOpen(false)
    }
    function windowKeyboardHandler(e: KeyboardEvent) {
      if (isOpen && e.key === "Escape") {
        setOpen(false)
      }
    }

    window.addEventListener("keydown", windowKeyboardHandler)
    window.addEventListener("click", windowClickHandler)

    return (): void => {
      window.removeEventListener("keydown", windowKeyboardHandler)
      window.removeEventListener("click", windowClickHandler)
    }
  }, [level, thisItem, isOpen])

  const hasSubnav = subLinks && subLinks.length > 0

  const hoverToggle =
    hasSubnav && props.level === 1 && isBrowser && window.innerWidth > parseFloat(tokens.breakpoint.md.value)

  return (
    <li
      ref={thisItem}
      className={`${styles.navlink} ${isOpen ? styles.open : ""}`}
      onMouseEnter={() => hoverToggle && setOpen(true)}
      onMouseLeave={() => hoverToggle && setOpen(false)}>
      <div
        className={`${styles.linkRow} ${isCurrentPage ? styles.isCurrentPage : ""} ${
          hasCurrentPage ? styles.hasCurrentPage : ""
        }`}>
        {props.link}
        {hasSubnav && (
          <button onClick={onOpenClick} title={isOpen ? "Close menu" : "Open menu"}>
            {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </button>
        )}
      </div>

      {hoverToggle && <div className={styles.hoverHelper} onClick={() => setOpen(false)}></div>}

      {/* unmountOnExit = ssr tilassa renderoidaan kaikki linkit, selamella renderoidaan vain näkyvät */}
      <CSSTransition in={isOpen} classNames="dropdown" timeout={600} unmountOnExit={isBrowser}>
        <ul className={`${styles[`subnav${level}`]}`} style={!isBrowser && !isOpen ? { display: "none" } : undefined}>
          {<NavLinks nodes={props.subLinks} level={level + 1} />}
        </ul>
      </CSSTransition>
    </li>
  )
}

export default NavLink
